<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <p class="text-primary"> <b>Completa los datos del recibo:</b> </p>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Lugar: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.lugar"> </div>
          </div>
          <div class="form-group" :class="{'has-error': validation.hasError('recibo.monto')}">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>*Monto: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="number" v-model.number="recibo.monto"> </div>
            <span class="error" v-if="validation.hasError('recibo.monto')"> {{validation.firstError('recibo.monto')}} </span>
          </div>
          <div class="form-group" :class="{'has-error': validation.hasError('recibo.nombres')}">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small> <small>*Estudiante:</small> </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.nombres"> </div>
            <span class="error" v-if="validation.hasError('recibo.nombres')"> {{validation.firstError('recibo.nombres')}} </span>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Carnet: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.carnet"> </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Telefono: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.telefono"> </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>N° Factura: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.celular"> </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group" :class="{'has-error': validation.hasError('recibo.nrecibo')}">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>*Nro Recibo: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.nrecibo"> </div>
            <span class="error" v-if="validation.hasError('recibo.nrecibo')"> {{validation.firstError('recibo.nrecibo')}} </span>
          </div>
          <div class="form-group" :class="{'has-error': validation.hasError('recibo.concepto')}">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>*Concepto: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.concepto"> </div>
            <span class="error" v-if="validation.hasError('recibo.concepto')"> {{validation.firstError('recibo.concepto')}} </span>
          </div>
          <div class="form-group" :class="{'has-error': validation.hasError('recibo.forma')}">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>*Forma de pago: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.forma"> </div>
            <span class="error" v-if="validation.hasError('recibo.forma')"> {{validation.firstError('recibo.forma')}} </span>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Saldo: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="number" v-model.number="recibo.saldo"> </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Nro. cuota: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.nro_cuota"> </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group" :class="{'has-error': validation.hasError('recibo.dia')}">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Dia: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.dia"> </div>
            <div class="error" v-if="validation.hasError('recibo.dia')"> {{validation.firstError('recibo.dia')}} </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Mes: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.mes"> </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Año: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.anio"> </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Proximo pago: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.prox"> </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Asesor: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.asesor"> </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label"> <small>Emisor: </small> </label>
            <div class="col-sm-10"> <input class="form-control input-sm" type="text" v-model="recibo.emisor"> </div>
          </div>

        </div>
      </div>

    </form>

    <button type="button" class="btn btn-success btn-sm" @click="generar()"> <span class="glyphicon glyphicon-refresh" style="color:white"></span> Generar </button>
    <button type="button" class="btn btn-info btn-sm" @click="limpiar()" style="margin-left:2px"> <span class="glyphicon glyphicon-check" style="color:white"></span> Limpiar </button>
    <button type="button" class="btn btn-success btn-sm" @click="guardar()" style="margin-left:32px"> <span class="glyphicon glyphicon-save" style="color:white"></span> Guardar PDF </button>
    <p class="text-center text-danger"> {{msg}} </p>

    <div class="xcard">
      <canvas id="myCanvasm" width="840" height="700" style="border:1px solid #55d3d3d3;"> </canvas>
      <!-- <button type="button" class="btn btn-success btn-sm" @click="guardar()"> Guardar PDF </button> -->
    </div>
    
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator'

export default {
  data(){
    return{
      recibo:{
        lugar:'',
        dia:'',
        mes:'',
        anio:'',
        monto:'',
        nombres:'',
        carnet:'',
        telefono:'',
        celular:'',
        concepto:'',
        forma:'',
        saldo:'',
        nro_cuota:'',
        prox:'',
        nrecibo:'',
        asesor:'',
        emisor:'',
      },
      image:null,
      msg:'',
    }
  },
  validators: {
    'recibo.monto'(value){ return Validator.value(value).required(); },
    'recibo.nrecibo'(value){ return Validator.value(value).required(); },
    'recibo.nombres'(value){ return Validator.value(value).required(); },
    'recibo.concepto'(value){ return Validator.value(value).required(); },
    'recibo.forma'(value){ return Validator.value(value).required(); },
    'recibo.dia'(value){ return Validator.value(value).required(); },
    'recibo.mes'(value){ return Validator.value(value).required(); },
    'recibo.anio'(value){ return Validator.value(value).required(); },
  },
  methods:{
    guardar(){
      var canvas = document.getElementById("myCanvasm");
      let width = canvas.width; 
      let height = canvas.height;
      var pdf;
      var nombre = this.recibo.nombres;

      if(width > height){
        pdf = new window.jsPDF('l', 'px', [width, height]);
      }
      else{
        pdf = new window.jsPDF('p', 'px', [height, width]);
      }

      width = pdf.internal.pageSize.getWidth();
      height = pdf.internal.pageSize.getHeight();
      pdf.addImage(canvas, 'JPG', 0, 0,width,height);
      pdf.save( nombre+".pdf");
    },
    limpiar(){
      this.recibo = {
        lugar:'',
        dia:'',
        mes:'',
        anio:'',
        monto:0,
        nombres:'',
        carnet:'',
        telefono:'',
        celular:'',
        concepto:'',
        forma:'',
        saldo:0,
        nro_cuota:0,
        prox:'',
        nrecibo:'',
        asesor:'',
      };
      this.defecto();
      this.generar();
    },
    cargarImage(){
      var canvas = document.getElementById("myCanvasm");
      var ctx = canvas.getContext("2d");
       // set size proportional to image
      canvas.height = canvas.width * (this.image.height / this.image.width);

      // step 1 - resize to 50%
      var oc = document.createElement('canvas'),
          octx = oc.getContext('2d');

      oc.width = this.image.width * 1.0;
      oc.height = this.image.height * 1.0;
      octx.drawImage(this.image, 0, 0, oc.width, oc.height);

      // step 2
      octx.drawImage(oc, 0, 0, oc.width * 1.0, oc.height * 1.0);

      // step 3, resize to final size
      ctx.drawImage(oc, 0, 0, oc.width * 1.0, oc.height * 1.0,
      0, 0, canvas.width, canvas.height);
    },
    generar(){
      var vue = this;
      vue.msg = '';
      //vue.generandoo();
      this.$validate().then((success) => {
        if( success ) vue.generandoo();
        else vue.msg = "Complete los campos obligatorios.";
      })
    },
    generandoo(){
      var c = document.getElementById("myCanvasm");
      var ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.width, c.height);
      ctx.drawImage(this.image, 0, 0, 840, 700);

      var am = this.$store.state.DATA_USER.seg_apellido;
      if( !this.recibo.asesor ){
        var asesor = this.$store.state.DATA_USER.nombres+' '+this.$store.state.DATA_USER.pri_apellido+' '+am;
        this.recibo.asesor = asesor;
      }
      if( !this.recibo.emisor ){
        var emisor = this.$store.state.DATA_USER.nombres+' '+this.$store.state.DATA_USER.pri_apellido+' '+am;
        this.recibo.emisor = emisor;
      }

      ctx.font = "17px Arial";
      ctx.textAlign = "center";
      ctx.fillText(""+this.recibo.lugar, (c.width/2)-330, 250);
      ctx.fillText(""+this.recibo.nombres, (c.width/2)-40, 342);
      ctx.fillText(""+this.recibo.emisor, c.width / 2 + 220, 548);
      ctx.fillText(""+this.recibo.asesor, c.width / 2 - 180, 548);
      ctx.fillText(""+this.recibo.carnet, (c.width/2)+270, 342);
      ctx.fillText(""+this.recibo.telefono, (c.width/2)+160, 390);
      ctx.fillText(""+this.recibo.celular, (c.width/2)+325, 390);
      ctx.fillText(""+this.recibo.concepto, (c.width/2)+50, 431);
      ctx.fillText(""+this.recibo.forma, (c.width/2)-180, 474);
      ctx.fillText(""+this.recibo.monto+" Bs.", (c.width/2)-270, 512);
      ctx.fillText(""+this.recibo.saldo+" Bs.", (c.width/2)-70, 512);
      ctx.fillText(""+this.recibo.nro_cuota, (c.width/2)+90, 512);
      ctx.fillText(""+this.recibo.monto, (c.width/2)+270, 215);
      ctx.fillText("--------", (c.width/2)+270, 255);
      ctx.font = "16px Arial";
      ctx.fillText(""+this.recibo.dia, (c.width/2)-230, 250);
      ctx.fillText(""+this.recibo.mes, (c.width/2)-180, 250);
      ctx.fillText(""+this.recibo.anio, (c.width/2)-135, 250);
      ctx.font = "24px Arial";
      ctx.fillText("N° "+this.recibo.nrecibo, (c.width/2)+10, 250);
      ctx.font = "17px Arial";

      ctx.fillText(""+this.recibo.prox, (c.width/2)+320, 512);
    },
    defecto(){
      var date = new Date();
      var dia = date.getDate();
      var mes = date.getMonth()+1;
      var mes2 = date.getMonth()+2;
      var anio = date.getFullYear();
      if( dia < 10 ) dia = '0'+dia;
      if( mes < 10 ) mes = '0'+mes;
      if( mes2 < 10 ) mes2 = '0'+mes2;
      this.recibo.dia = dia;
      this.recibo.mes = mes;
      this.recibo.anio = anio;
      if (mes2 > 12) {
        mes2 = '01';
        anio = anio+1;
      }
      this.recibo.prox = '15/'+mes2+'/'+anio;
      var am = this.$store.state.DATA_USER.seg_apellido;
      if( !am ) am = "";
      var asesor = this.$store.state.DATA_USER.nombres+' '+this.$store.state.DATA_USER.pri_apellido+' '+am;
      this.recibo.asesor = asesor;
    }
  },
  mounted(){
    var vue = this;
    // var iduser = this.$store.state.DATA_USER.id;
    // if( iduser == 31 ) img = "img/recibo_andrea.png";
    // else if( iduser == 74 ) img = "img/recibo_celina.jpg";
    // else if( iduser == 10730 ) img = "img/recibo_grecia.png";
    // else if( iduser == 8740 ) img = "img/recibo_ecoca.png";
    // else if( iduser == 11155 ) img = "img/recibo_jtrigo.png";
    // else if( iduser == 3522 ) img = "img/recibo_pgarcia.png";
    // else if( iduser == 1406 ) img = "img/recibo_pmontoya.png";
    // else if( iduser == 1405 ) img = "img/recibo_mguevara.png";
    // else if( iduser == 818 ) img = "img/recibo_oarancibia.png";
    // else if( iduser == 18 ) img = "img/recibo_raquel.png";
    // else if( iduser == 3145 ) img = "img/recibo_afernandez.png";
    // else if( iduser == 3506 ) img = "img/recibo_mcarvajal.png";
    // else if( iduser == 3522 ) img = "img/recibo_pgarcia.png";
    // else if( iduser == 11004 ) img = "img/recibo_apacheco.png";
    // else if( iduser == 11219 ) img = "img/recibo_grodriguez.png";
    // else if( iduser == 6476 ) img = "img/recibo_lvasquez.png";

    let sede = this.$store.state.CARGO.sede;
    if (sede.modelo_recibo) {
      this.image = new Image();
      this.image.src = process.env.VUE_APP_URL_BG_RECIBO_SEDE + sede.modelo_recibo;
      this.image.onload = function(){
        //vue.cargarImage()
        vue.defecto();
        vue.generandoo();
      };
    } else {
      this.$root.$notify.show('La Sede No tiene Un fondo definido', {color:'red', timeout: 10000})
    }
    
  }
}
</script>